import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ES6Parser, ES6StaticEval } from 'espression';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-number-exp',
  styleUrls: ['form-numberExp.component.scss'],
  template: `
    @if (props.label) {
      <label
        for="number-exp-{{ field.key }}"
        class="section col-12"
        tabindex="0"
        [innerHTML]="props.label"
      ></label>
    }
    @if (props.prompt) {
      <p class="explanation" tabindex="0" [innerHTML]="props.prompt"></p>
    }
    <mat-form-field floatPlaceholder="auto" class="w-100">
      <mat-label>{{ to.placeholder }}</mat-label>
      <input
        id="number-exp-{{ field.key }}"
        min="{{ props.min }}"
        max="{{ props.max }}"
        matInput
        type="number"
        [placeholder]="props.placeholder || props.label"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        (wheel)="$event.preventDefault()"
      />
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyNumberExpComponent extends FieldType implements OnInit {
  ngOnInit(): void {
    this.formControl.valueChanges.subscribe(value => {
      if (
        this.props.maxLength &&
        value.toString().length > this.props.maxLength
      ) {
        this.formControl.setValue(
          this.formControl.value.toString().slice(0, this.props.maxLength)
        );
      }
    });
  }
  stringEval(str) {
    const parser = new ES6Parser();
    const staticEval = new ES6StaticEval();

    const ast = parser.parse(str.replace('.', '_'));
    return staticEval.evaluate(ast);
  }
}
